import { useJob, useJobStart } from "@/api";
import AppFrame from "@/components/apps/AppFrame";
import { ToolHashType } from "@/gql/__generated__/graphql";
import { JOB_STATUSES, JobStatus } from "../assets/jobStatus";
import { useJobHeartbeat } from "../hooks/jobHeartbeat";
import AppError from "./AppError";

interface Props {
  appHash: string;
  hashType: ToolHashType;
}

function AppPage({ appHash, hashType }: Props) {
  const [startJob, jobStartResult] = useJobStart({
    toolHash: appHash,
    hashType
  });
  const { data, loading, error, called, stopPolling } = useJob({
    toolHash: appHash,
    hashType
  });
  if (!jobStartResult.called) startJob();

  const proxyUrl = data?.job?.proxyUrl;
  const status = data?.job?.status?.toLocaleLowerCase() as
    | JobStatus
    | undefined;
  const jobReady = !!(
    status === JobStatus.Running &&
    proxyUrl &&
    !loading &&
    !error
  );
  const getJobDataError = !!(
    called &&
    status &&
    !JOB_STATUSES.includes(status)
  );
  const initializeJobError = error || jobStartResult.error || getJobDataError;

  useJobHeartbeat({ jobId: data?.job?.id || "", activateHeartbeat: jobReady });

  if (jobReady || initializeJobError) stopPolling();

  if (initializeJobError) {
    if (error) console.error(error);
    if (jobStartResult.error) console.error(jobStartResult.error);
    if (getJobDataError) console.error("Unknown job status:", status);

    return <AppError />;
  }

  return <AppFrame proxyUrl={proxyUrl || ""} ready={jobReady} />;
}

export default AppPage;
